import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './profile.scss'
import imageAvatar from '../../../../assets/images/avatar.png'
import { AUTH_SAVE } from '../../../../redux/reducers/auth/action-types'

const Profile = (props) => {
    const onLogout = () => {
        sessionStorage.removeItem('auth')
        props.dispatch({
            type: AUTH_SAVE,
            payload: {}
        })
        props.history.push('/auth/login')
    }

    return (
        <div className="profile">
            <div>
                <div className="img-cont">
                    <img src={imageAvatar} alt="" />
                </div>
                <strong>{props.auth.firstname} {props.auth.lastname}</strong>
                <button type="button" className="logout-btn" onClick={onLogout}>Logout</button>
                <div className="clearfix"></div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Profile))
